import React, { useEffect, useState } from "react";
import Footer from "../../components/layout/Footer";

import { withRouter } from "react-router";
import CoursesSection from "./components/CoursesSection";
import GetStartedSection from "./components/GetStartedSection";
import SchoolHeader from "./components/SchoolHeader";

import { Helmet } from "react-helmet";
import Preloader from "../../components/blocks/Preloader";
import TestimonySection from "../../components/blocks/TestimonySection";
import useSelectedLocation from "../../helpers/useSelectedLocation";
import Error404 from "../Error404";
import TalentWorkSection from "./components/TalentWorkSection";
import {
  artificialIntelligenceSchoolDataAfrica,
  blockchainSchoolDataAfrica,
  businessAnalysisSchoolDataAfrica,
  cloudComputingSchoolDataAfrica,
  cyberSecuritySchoolAfrica,
  dataSchoolDataAfrica,
  // designSchoolDataAfrica,
  marketingSchoolDataAfrica,
  productMarketingSchoolDataAfrica,
  productSchoolDataAfrica,
  programmingSchoolDataAfrica,
} from "./components/data/africa";
import {
  artificialIntelligenceSchoolDataEurope,
  businessAnalysisSchoolDataEurope,
  cloudComputingSchoolDataEurope,
  dataSchoolDataEurope,
  // designSchoolDataEurope,
  marketingSchoolDataEurope,
  productSchoolDataEurope,
  programmingSchoolDataEurope,
} from "./components/data/europe";
import { productMarketingSchoolDataEurope } from "./components/data/europe/productMarketingSchoolDataEurope";

const DataSchool = (props) => {
  const selectedLocation = useSelectedLocation();
  const [selectedSchoolData, setSelectedSchoolData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const schoolName = props.location.pathname.slice(8);
    renderPageBasedOnSelectedSchoolData(schoolName);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname, selectedLocation]);

  const renderPageBasedOnSelectedSchoolData = (school) => {
    switch (school) {
      case "data-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? dataSchoolDataAfrica
            : dataSchoolDataEurope
        );
        break;

      case "business-analysis-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? businessAnalysisSchoolDataAfrica
            : businessAnalysisSchoolDataEurope
        );
        break;

      case "blockchain-developer-school":
        setSelectedSchoolData(blockchainSchoolDataAfrica);
        break;

      case "cloud-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? cloudComputingSchoolDataAfrica
            : cloudComputingSchoolDataEurope
        );
        break;

      case "product-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? productSchoolDataAfrica
            : productSchoolDataEurope
        );
        break;

      case "product-marketing-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? productMarketingSchoolDataAfrica
            : productMarketingSchoolDataEurope
        );
        break;

      // case "design-school":
      //   setSelectedSchoolData(
      //     selectedLocation?.name === "Africa" || selectedLocation === undefined
      //       ? designSchoolDataAfrica
      //       : designSchoolDataEurope
      //   );
      //   break;

      case "ai-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? artificialIntelligenceSchoolDataAfrica
            : artificialIntelligenceSchoolDataEurope
        );
        break;

      case "marketing-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? marketingSchoolDataAfrica
            : marketingSchoolDataEurope
        );
        break;

      case "programming-school":
        setSelectedSchoolData(
          selectedLocation?.name === "Africa" || selectedLocation === undefined
            ? programmingSchoolDataAfrica
            : programmingSchoolDataEurope
        );
        break;

      case "cybersecurity-school":
        setSelectedSchoolData(cyberSecuritySchoolAfrica);
        break;

      default:
        setSelectedSchoolData(null);
        return;
    }
  };

  if (loading) {
    return <Preloader />;
  }

  return (
    <div>
      {selectedSchoolData ? (
        <>
          <Helmet>
            <title>{selectedSchoolData.name}</title>
            <meta name="keywords" content={selectedSchoolData.keywords} />
            <meta name="description" content={selectedSchoolData.metatags} />
          </Helmet>

          <SchoolHeader
            selectedLocation={selectedLocation}
            selectedSchoolData={selectedSchoolData}
          />

          <CoursesSection
            selectedLocation={selectedLocation}
            selectedSchoolData={selectedSchoolData}
          />

          <TestimonySection />

          <GetStartedSection selectedSchoolData={selectedSchoolData} />
          <TalentWorkSection />
          <Footer />
        </>
      ) : (
        <Error404
          content={
            <>
              Oops! The page you are looking for does not exist.
              <br />
              We don't have this program at the moment. Do check back later
            </>
          }
          linkName="Go back to Home page"
          linkUrl="/"
        />
      )}
    </div>
  );
};

export default withRouter(DataSchool);
